import { IFormNewUncertainty } from "../../../types/uncertainty.types";
export const uncertaintyMap = (uncertainty: IFormNewUncertainty) => {
  return {
    id: uncertainty.id,
    /*     analyst: uncertainty.analyst?.id, */
    date: uncertainty.date,
    eumpp: uncertainty.eumpp ? parseFloat(uncertainty.eumpp as any) : null,
    eumps: uncertainty.eumps ? parseFloat(uncertainty.eumps as any) : null,
    mass_uncertainty_tertiary_pattern:
      uncertainty.mass_uncertainty_tertiary_pattern
        ? parseFloat(uncertainty.mass_uncertainty_tertiary_pattern as any)
        : null,
    euvps_btr: uncertainty.euvps_btr
      ? parseFloat(uncertainty.euvps_btr as any)
      : null,
    eumps_h3: uncertainty.eumps_h3
      ? parseFloat(uncertainty.eumps_h3 as any)
      : null,
    eump_k40: uncertainty.eump_k40
      ? parseFloat(uncertainty.eump_k40 as any)
      : null,
    euvps: uncertainty.euvps ? parseFloat(uncertainty.euvps as any) : null,
    uncertainty_source_pat_terc: uncertainty.uncertainty_source_pat_terc
      ? parseFloat(uncertainty.uncertainty_source_pat_terc as any)
      : null,
    /*     uncertainty_date: new Date(uncertainty.date), */
    evh3_d: uncertainty.evh3_d ? parseFloat(uncertainty.evh3_d as any) : null,
    evh3_c: uncertainty.evh3_c ? parseFloat(uncertainty.evh3_c as any) : null,
    evh3: uncertainty.evh3 ? parseFloat(uncertainty.evh3 as any) : null,
    result_bq_l: parseFloat(uncertainty.result_bq_l as any),
    k40_calibration_source_vol_uncertainty: parseFloat(
      uncertainty.k40_calibration_source_vol_uncertainty as any
    ),
    /*     k2_calibration_source_vol_uncertainty: parseFloat(
      uncertainty.k2_calibration_source_vol_uncertainty as any
    ), */
    /*     k1_u2_vol_uncertainty: parseFloat(uncertainty.k1_u2_vol_uncertainty as any), */
    emh3_d: uncertainty.emh3_d ? parseFloat(uncertainty.emh3_d as any) : null,
    emh3_c: uncertainty.emh3_c ? parseFloat(uncertainty.emh3_c as any) : null,
    emh3: uncertainty.emh3 ? parseFloat(uncertainty.emh3 as any) : null,
    k2_calibration_source_mass_uncertainty: parseFloat(
      uncertainty.k2_calibration_source_mass_uncertainty as any
    ),
    k1U2_g_calibration_source_mass_uncertainty: parseFloat(
      uncertainty.k1U2_g_calibration_source_mass_uncertainty as any
    ),
    tipo_incertidumbre: uncertainty.tipo_incertidumbre?.id,
    internal_comments: uncertainty.internal_comments,
    analyst: uncertainty.analyst?.id,
    volume_water_1ml_k2_ml: uncertainty.volume_water_1ml_k2_ml
      ? parseFloat(uncertainty.volume_water_1ml_k2_ml as any)
      : null,
    volume_water_1ml_k2_m3: uncertainty.volume_water_1ml_k2_m3
      ? parseFloat(uncertainty.volume_water_1ml_k2_m3 as any)
      : null,
    volume_water_1ml_k1_m3_2: uncertainty.volume_water_1ml_k1_m3_2
      ? parseFloat(uncertainty.volume_water_1ml_k1_m3_2 as any)
      : null,
    volume_water_1ml_k1_l_kg: uncertainty.volume_water_1ml_k1_l_kg
      ? parseFloat(uncertainty.volume_water_1ml_k1_l_kg as any)
      : null,
    volume_water_1ml_k1_g_2: uncertainty.volume_water_1ml_k1_g_2
      ? parseFloat(uncertainty.volume_water_1ml_k1_g_2 as any)
      : null,
    volume_water_5ml_k2_ml: uncertainty.volume_water_5ml_k2_ml
      ? parseFloat(uncertainty.volume_water_5ml_k2_ml as any)
      : null,
    volume_water_5ml_k2_m3: uncertainty.volume_water_5ml_k2_m3
      ? parseFloat(uncertainty.volume_water_5ml_k2_m3 as any)
      : null,
    volume_water_5ml_k1_m3_2: uncertainty.volume_water_5ml_k1_m3_2
      ? parseFloat(uncertainty.volume_water_5ml_k1_m3_2 as any)
      : null,
    volume_water_5ml_k1_l_kg: uncertainty.volume_water_5ml_k1_l_kg
      ? parseFloat(uncertainty.volume_water_5ml_k1_l_kg as any)
      : null,
    volume_water_5ml_k1_g_2: uncertainty.volume_water_5ml_k1_g_2
      ? parseFloat(uncertainty.volume_water_5ml_k1_g_2 as any)
      : null,
    volume_water_25ml_k2_ml: uncertainty.volume_water_25ml_k2_ml
      ? parseFloat(uncertainty.volume_water_25ml_k2_ml as any)
      : null,
    volume_water_25ml_k2_m3: uncertainty.volume_water_25ml_k2_m3
      ? parseFloat(uncertainty.volume_water_25ml_k2_m3 as any)
      : null,
    volume_water_25ml_k1_m3_2: uncertainty.volume_water_25ml_k1_m3_2
      ? parseFloat(uncertainty.volume_water_25ml_k1_m3_2 as any)
      : null,
    volume_water_25ml_k1_l_kg: uncertainty.volume_water_25ml_k1_l_kg
      ? parseFloat(uncertainty.volume_water_25ml_k1_l_kg as any)
      : null,
    volume_water_25ml_k1_g_2: uncertainty.volume_water_25ml_k1_g_2
      ? parseFloat(uncertainty.volume_water_25ml_k1_g_2 as any)
      : null,
    volume_water_500ml_k2_ml: uncertainty.volume_water_500ml_k2_ml
      ? parseFloat(uncertainty.volume_water_500ml_k2_ml as any)
      : null,
    volume_water_500ml_k2_m3: uncertainty.volume_water_500ml_k2_m3
      ? parseFloat(uncertainty.volume_water_500ml_k2_m3 as any)
      : null,
    volume_water_500ml_k1_m3_2: uncertainty.volume_water_500ml_k1_m3_2
      ? parseFloat(uncertainty.volume_water_500ml_k1_m3_2 as any)
      : null,
    volume_water_500ml_k1_l_kg: uncertainty.volume_water_500ml_k1_l_kg
      ? parseFloat(uncertainty.volume_water_500ml_k1_l_kg as any)
      : null,
    volume_water_500ml_k1_g_2: uncertainty.volume_water_500ml_k1_g_2
      ? parseFloat(uncertainty.volume_water_500ml_k1_g_2 as any)
      : null,
    volume_sea_5ml_k2_ml: uncertainty.volume_sea_5ml_k2_ml
      ? parseFloat(uncertainty.volume_sea_5ml_k2_ml as any)
      : null,
    volume_sea_5ml_k2_m3: uncertainty.volume_sea_5ml_k2_m3
      ? parseFloat(uncertainty.volume_sea_5ml_k2_m3 as any)
      : null,
    volume_sea_5ml_k1_m3_2: uncertainty.volume_sea_5ml_k1_m3_2
      ? parseFloat(uncertainty.volume_sea_5ml_k1_m3_2 as any)
      : null,
    volume_sea_5ml_k1_l_kg: uncertainty.volume_sea_5ml_k1_l_kg
      ? parseFloat(uncertainty.volume_sea_5ml_k1_l_kg as any)
      : null,
    volume_sea_5ml_k1_g_2: uncertainty.volume_sea_5ml_k1_g_2
      ? parseFloat(uncertainty.volume_sea_5ml_k1_g_2 as any)
      : null,
    mass_solid_5ml_k2_mg: uncertainty.mass_solid_5ml_k2_mg
      ? parseFloat(uncertainty.mass_solid_5ml_k2_mg as any)
      : null,
    mass_solid_5ml_k2_kg: uncertainty.mass_solid_5ml_k2_kg
      ? parseFloat(uncertainty.mass_solid_5ml_k2_kg as any)
      : null,
    mass_solid_5ml_k1_kg_2: uncertainty.mass_solid_5ml_k1_kg_2
      ? parseFloat(uncertainty.mass_solid_5ml_k1_kg_2 as any)
      : null,
    mass_solid_5ml_k1_g_2: uncertainty.mass_solid_5ml_k1_g_2
      ? parseFloat(uncertainty.mass_solid_5ml_k1_g_2 as any)
      : null,
    mass_solid_200g_k2_mg: uncertainty.mass_solid_200g_k2_mg
      ? parseFloat(uncertainty.mass_solid_200g_k2_mg as any)
      : null,
    mass_solid_200g_k2_kg: uncertainty.mass_solid_200g_k2_kg
      ? parseFloat(uncertainty.mass_solid_200g_k2_kg as any)
      : null,
    mass_solid_200g_k1_g_2: uncertainty.mass_solid_200g_k1_g_2
      ? parseFloat(uncertainty.mass_solid_200g_k1_g_2 as any)
      : null,
    mass_solid_200g_k1_kg_2: uncertainty.mass_solid_200g_k1_kg_2
      ? parseFloat(uncertainty.mass_solid_200g_k1_kg_2 as any)
      : null,
    mass_sample_us_k2_mg: uncertainty.mass_sample_us_k2_mg
      ? parseFloat(uncertainty.mass_sample_us_k2_mg as any)
      : null,
    mass_sample_us_k2_g: uncertainty.mass_sample_us_k2_g
      ? parseFloat(uncertainty.mass_sample_us_k2_g as any)
      : null,
    mass_sample_u2s_k1_g2: uncertainty.mass_sample_u2s_k1_g2
      ? parseFloat(uncertainty.mass_sample_u2s_k1_g2 as any)
      : null,
    mass_sample_ub_k2_mg: uncertainty.mass_sample_ub_k2_mg
      ? parseFloat(uncertainty.mass_sample_ub_k2_mg as any)
      : null,
    mass_sample_ub_k2_g: uncertainty.mass_sample_ub_k2_g
      ? parseFloat(uncertainty.mass_sample_ub_k2_g as any)
      : null,
    mass_sample_u2b_k1_g2: uncertainty.mass_sample_u2b_k1_g2
      ? parseFloat(uncertainty.mass_sample_u2b_k1_g2 as any)
      : null,
    mass_solid_minor_200g_k2_mg: uncertainty.mass_solid_minor_200g_k2_mg
      ? parseFloat(uncertainty.mass_solid_minor_200g_k2_mg as any)
      : null,
    mass_solid_minor_200g_k2_kg: uncertainty.mass_solid_minor_200g_k2_kg
      ? parseFloat(uncertainty.mass_solid_minor_200g_k2_kg as any)
      : null,
    mass_solid_minor_200g_k1_kg_2: uncertainty.mass_solid_minor_200g_k1_kg_2
      ? parseFloat(uncertainty.mass_solid_minor_200g_k1_kg_2 as any)
      : null,
    mass_solid_minor_200g_k1_g_2: uncertainty.mass_solid_minor_200g_k1_g_2
      ? parseFloat(uncertainty.mass_solid_minor_200g_k1_g_2 as any)
      : null,
    AA_k2: uncertainty.AA_k2 ? parseFloat(uncertainty.AA_k2 as any) : null,
    AA_k1: uncertainty.AA_k1 ? parseFloat(uncertainty.AA_k1 as any) : null,
    NI_k2: uncertainty.NI_k2 ? parseFloat(uncertainty.NI_k2 as any) : null,
    NI_k1: uncertainty.NI_k1 ? parseFloat(uncertainty.NI_k1 as any) : null,
    FE_k2: uncertainty.FE_k2 ? parseFloat(uncertainty.FE_k2 as any) : null,
    FE_k1: uncertainty.FE_k1 ? parseFloat(uncertainty.FE_k1 as any) : null,
    NI_MG_k2: uncertainty.NI_MG_k2
      ? parseFloat(uncertainty.NI_MG_k2 as any)
      : null,
    NI_MG_k1: uncertainty.NI_MG_k1
      ? parseFloat(uncertainty.NI_MG_k1 as any)
      : null,
    NI_FE_k2: uncertainty.NI_FE_k2
      ? parseFloat(uncertainty.NI_FE_k2 as any)
      : null,
    NI_FE_k1: uncertainty.NI_FE_k1
      ? parseFloat(uncertainty.NI_FE_k1 as any)
      : null,
    //mass_solid_25ml_k2_kg: parseFloat(uncertainty.mass_solid_25ml_k2_kg as any),
    //mass_solid_25ml_k1_kg_2: parseFloat(uncertainty.mass_solid_25ml_k1_kg_2 as any),
    //mass_solid_25ml_k1_g_2: parseFloat(uncertainty.mass_solid_25ml_k1_g_2 as any),
    //mass_solid_200g_k1_mg_2:parseFloat(uncertainty.mass_solid_200g_k1_mg_2 as any),
    inc_vol_sample_k2_l: uncertainty.inc_vol_sample_k2_l
      ? parseFloat(uncertainty.inc_vol_sample_k2_l as any)
      : null,
    inc_vol_sample_k2_2_m3: uncertainty.inc_vol_sample_k2_2_m3
      ? parseFloat(uncertainty.inc_vol_sample_k2_2_m3 as any)
      : null,
    inc_vol_sample_k1_u2_m3_2: uncertainty.inc_vol_sample_k1_u2_m3_2
      ? parseFloat(uncertainty.inc_vol_sample_k1_u2_m3_2 as any)
      : null,
  };
};
